














import { Component, Prop, Vue } from 'vue-property-decorator';
import Tab from './Tab.vue';

@Component
export default class Tabs extends Vue {
	activeTab: Tab | null = null;
	tabs: Tab[] = [];

	@Prop(String) headerClass!: string;

	public get selectedTab() {
	    return this.activeTab;
	}

	public toggle(name: string) {
	    if (this.activeTab?.name === name) return false;

	    for (const tab of this.tabs) {
	        if (tab.name === name) {
	            this.activeTab = tab;
	            tab.toggle(true);
	            this.$emit('changed', tab.name);
	        } else {
	            tab.toggle(false);
	        }
	    }

	    return true;
	}

	setup() {
	    this.tabs = this.$children.filter(x => x.$options.name === 'Tab') as Tab[];
	    for (const tab of this.tabs) {
	        if (tab.isActive) {
	            this.activeTab = tab;
	            break;
	        }
	    }

	    // Always show atleast 1 tab
	    if (!this.activeTab) {
	        const activeTab = this.tabs[0];
	        this.activeTab = activeTab;
	        activeTab.toggle(true);
	    }
	}

	mounted() {
	    this.setup();
	}
}
